import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/img/icon-cog.svg'


const _hoisted_1 = { class: "header-wrapper" }
const _hoisted_2 = { class: "menu" }
const _hoisted_3 = { class: "hide-sm avatar--user subtitle" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  class: "type-button-02",
  href: "#"
}
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["toolbar", { open: _ctx.navOpen }])
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "nav-toggle",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClickToggleNav && _ctx.handleClickToggleNav(...args)))
        }, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("span", null, null, -1),
          _createElementVNode("span", null, null, -1),
          _createElementVNode("span", null, null, -1)
        ]))]),
        _cache[7] || (_cache[7] = _createElementVNode("span", { id: "headerSlot" }, null, -1))
      ]),
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", {
          onMouseover: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleHoverToggleMenu($event))),
          onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleHoverToggleMenu($event)))
        }, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClickToggleMenu($event)))
          }, [
            _createVNode(_component_Avatar, {
              image: _ctx.user.profileImage,
              text: `${_ctx.user.firstName[0]}${_ctx.user.surname[0]}`,
              size: "sm"
            }, null, 8, ["image", "text"]),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.surname), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["submenu", { open: _ctx.menuOpen }])
          }, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (menuItem) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: menuItem.id,
                  onClick: _withModifiers(($event: any) => (_ctx.handleClickMenuItem($event, _ctx.$index, menuItem)), ["prevent"])
                }, [
                  _createElementVNode("a", {
                    class: "type-button-02",
                    href: menuItem.url
                  }, [
                    _createVNode(_component_TranslatedText, {
                      path: menuItem.title
                    }, null, 8, ["path"])
                  ], 8, _hoisted_5)
                ], 8, _hoisted_4))
              }), 128)),
              _createElementVNode("li", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"]))
              }, [
                _createElementVNode("a", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_TranslatedText, { path: "auth.logout" })
                  ])
                ])
              ])
            ])
          ], 2)
        ], 32),
        (_ctx.hasSettings)
          ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleClickToggleSettings($event)))
              }, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("img", {
                  class: "icon",
                  src: _imports_0,
                  alt: ""
                }, null, -1)
              ]))])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}